<div class="group-marcadores" *ngIf="!home">
  <div class="marcador-min"
    [style.margin-left]="valores[0]+'%'"
  >
    Min
    <icons-primecap [size]="'small'" [name]="'arrow-down'"></icons-primecap>
  </div>

</div>
<div class="progress position-relative">
  <div class="progress-bar pb-captado" role="progressbar" [style.width]="valores[1]+'%'" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
    <span class="justify-content-center position-absolute d-flex w-100" *ngIf="valores[1] > 0">
      {{ valores[1] + '%' }}
    </span>
  </div>
</div>
